import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PrimaryTextField from "../../../Inputs/PrimaryTextField/PrimaryTextField";
import FilterButton from "../../../Buttons/FilterButton/FilterButton";
import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../Buttons/SecondaryButton/SecondaryButton";
import StyledPopover from "../../../StyledPopover/StyledPopover";
import SortToggleButtons from "../../../Buttons/ToggleButtons/SortToggleButtons/SortToggleButtons";
import { Box } from "@mui/system";

export default function MultiOptionsFilter({
  column: { filterValue, setFilter, Header, toggleSortBy, clearSortBy }
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState("");
  const [alignment, setAlignment] = useState("ascending");
  const [title, setTitle] = useState("");
  const [label, setLabel] = useState("");
  const col = Header;


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEnter = () => {
    setFilter(value || undefined);
    onToggleSortBy();
    handleClose();
  };

  const handleClear = () => {
    setFilter(undefined);
    setValue("");
    setAlignment("ascending");
    clearSortBy();
    handleClose();
  };

  const onToggleSortBy = () => {
    switch (alignment) {
      case "descending":
        toggleSortBy(true);
        break;
      case "ascending":
        toggleSortBy(false);
        break;
      default:
        clearSortBy();
    }
  };

  useEffect(() => {
    if (filterValue) {
      setValue(filterValue);
    } else {
      setValue("");
    }
  }, [filterValue]);

  useEffect(() => {
    switch (col) {
      case "O-S":
        setTitle("Sort by Origin State"); setLabel("Origin State(s)");
        break;
      case "D-S":
        setTitle("Sort by Destination State"); setLabel("Destination State(s)");
        break;
      default:
        setTitle(`Sort by ${Header}`); setLabel("State(s)");
        break;
    }
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <FilterButton
        filterValue={filterValue}
        onClick={handleClick}
      />
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        title={title}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box >
          <SortToggleButtons alignment={alignment} setAlignment={setAlignment} />
        </Box>
        <Box sx={{ padding: "10px 0px 20px 0px" }}>
          <PrimaryTextField
            id={`multiple-options-filter-${label}`}
            width="300px"
            value={value}
            label={label}
            onChange={value => {
              setValue(value.toUpperCase());
            }}
            onEnter={() => {
              handleEnter();
            }}
            placeholder={"CA/MI-GA,IL.TX:FL"}
          />
        </Box>
        <Box sx={{ display: "flex" }}>
          <SecondaryButton
            label="Clear"
            onClick={handleClear}
          />
          <Box sx={{ margin: "0 20px 0 auto" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleClose}
            />
          </Box>
          <PrimaryButton
            label="Go"
            onClick={handleEnter}
            width="50px"
          />
        </Box>
      </StyledPopover>
    </>
  );
}

MultiOptionsFilter.propTypes = {
  column: PropTypes.object.isRequired,
};